<template>
    <div class="bg-white px-3 index" >
        <div class="add_tits" ref="titles">
            <el-form class="form-inlines " :inline="true">
                <el-form-item>
                    <el-button type="primary" icon="el-icon-refresh" size="small" @click="handleSync">同步选品组
                    </el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="ibox-content">
            <el-table :data="tableData" border v-loading="loading" :height="height" class="tableLimit">
                <el-table-column prop="id" label="ID"> </el-table-column>
                <el-table-column prop="adzoneid" label="adzoneid"> </el-table-column>
                <el-table-column prop="favorites_id" label="选品组ID"> </el-table-column>
                <el-table-column prop="favorites_title" label="选品组名称"> </el-table-column>
                <el-table-column prop="create_at" label="同步时间"> </el-table-column>>
            </el-table>
             <div class="u-f u-ac u-jsb ft_mr">
                <div></div>
                <div>
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[15, 30, 50, 100]" :page-size="pagesize"
                        layout="total, sizes, prev, pager, next, jumper" :total="count">
                    </el-pagination>
                </div>
            </div>
        </div>

    </div>
</template>


<script>
    import {
        mapState
    } from 'vuex'
    export default {
        data() {
            return {
                loading: false,
                tableData: [],
                count: 0,
                currentPage: 1,
                pagesize: 15,
                height: null,
            };
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        mounted() {
            let that = this
            that.getHeight()
            that.begin()
        },
        methods: {
            getHeight() {
                let that = this
                var titles = that.$refs.titles.offsetHeight
                that.height = window.innerHeight - titles - 200 + 'px'
                window.onresize = () => {
                    var titles = that.$refs.titles.offsetHeight
                    that.height = window.innerHeight - titles - 200 + 'px'
                }
            },
            // 搜索
            begin() {
                let that = this
                  that.currentPage=1
                that.pagesize=15
                that.search()
            },
            search() {
                let that = this
                that.tableData = []
                that.loading = true
                axios
                    .post("/admin/TbkSelectionGroup/m_showlist", {
                        source: 'wxjg',
                         page: that.currentPage,
                        page_count:that.pagesize
                    },{token:true})
                    .then(response => {
                        that.loading = false
                        that.tableData = response.data.data.list
                        that.count = response.data.data.total
                    })
                    .catch(error => {})
            },
            handleSizeChange(val) {
                let that = this
                that.pagesize = val;
                that.search()
            },
            handleCurrentChange(val) {
                let that = this
                that.currentPage = val;
                that.search()
            },
            // 同步
            handleSync(){
                let that = this
                axios
                    .post("/admin/TbkSelectionGroup/MSynchronousUpdateSelectionGroup", {
                        source: 'wxjg',
                    },{token:true})
                    .then(response => {
                        if (response.data.code == "200") {
                            that.begin()
                            that.$message({
                                showClose: true,
                                message: response.data.msg,
                                type: 'success'
                            });
                        } else {
                            that.$alert(response.data.message)
                        }
                    })
                    .catch(error => {})
            },
        },

    };
</script>


<style scoped>
</style>